export default "__VITE_ASSET__CBBpAd_W__"